import { ProductsApi } from './permission-api-client';
import { initializePermissionApi } from './utils';

export const productsApi = initializePermissionApi(ProductsApi);
